import Icon from '@/components/ui/AppIcon';

interface CategorySectionProps {
  title: string;
  description: string;
  icon: string;
  storyCount: number;
}

const CategorySection = ({
  title,
  description,
  icon,
  storyCount,
}: CategorySectionProps) => {
  return (
    <div className="bg-gradient-to-br from-primary/10 to-secondary/10 rounded-xl p-6 hover:shadow-warm-lg transition-all duration-300 cursor-pointer group">
      <div className="flex items-start justify-between mb-4">
        <div className="p-3 bg-primary text-primary-foreground rounded-lg group-hover:scale-110 transition-transform duration-300">
          <Icon name={icon as any} size={28} />
        </div>

        <span className="px-3 py-1 bg-card text-text-primary text-sm font-medium rounded-full">
          {storyCount} stories
        </span>
      </div>

      <h3 className="text-xl font-heading font-bold text-text-primary mb-2 group-hover:text-primary transition-colors duration-200">
        {title}
      </h3>

      <p className="text-sm text-text-secondary line-clamp-2">{description}</p>

      <div className="mt-4 flex items-center text-primary font-medium text-sm group-hover:translate-x-2 transition-transform duration-300">
        <span>Explore {title}</span>
        <Icon name="ChevronRightIcon" size={16} className="ml-1" />
      </div>
    </div>
  );
};

export default CategorySection;